import { render, staticRenderFns } from "./PostEditImmoObject3200.vue?vue&type=template&id=5f660085&"
import script from "./PostEditImmoObject3200.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoObject3200.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports